import { render, staticRenderFns } from "./data-summary-table.vue?vue&type=template&id=53c329e4"
import script from "./data-summary-table.vue?vue&type=script&lang=ts"
export * from "./data-summary-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports